// extracted by css-extract-rspack-plugin
export default {"line":"line-km88N8","info":"info-ilxYjd","channel":"channel-C6LbWl"};